import { MARKER_END} from './MarkerEndTypes'

const initialState = {
    markerEnd: ""
}

const markerEndReducer = (state = initialState, action) => {
    
    switch (action.type) {
        case MARKER_END:
            
            return {
                markerEnd: action.load
            }
    
        default:
          return state
    }

}


export default markerEndReducer;